export class SignupParams {
    public static readonly MarginTopPrimary = 55;
    public static readonly MarginTopSecondary = 215;
    public static readonly PassedStepIconPath = '../Content/xpress-app/images/operator/signup/signup-step-check.svg';
    public static readonly UploadFilesIconPath = '../Content/xpress-app/images/operator/signup/upload_files.svg';

    public static readonly PassedStep = 'passed-step';
    public static readonly CurrentStep = 'current-step';
    public static readonly NextStep = 'next-step';

    public static readonly ContinueBtn = 'Continue';
    public static readonly NextBtn = 'Next';
    public static readonly SignupBtn = 'Signup';
    public static readonly SignupSubmitBtn = 'Sign up & Submit';

    public static readonly FirstTitle = `Let's get you set up`;
    public static readonly FirstSubtitle = 'Fill in your details to continue.';
    public static readonly ThirdTitle = 'Business Requirements';
    public static readonly ThirdSubtitle = 'Start by uploading a government-issued ID. We may request additional documents later.';
    public static readonly SecondTitle = 'Create your password';
    public static readonly SecondSubtitle = 'Set a password to secure and finish setting up your operator account.';
    public static readonly ReviewTitle = 'Review & Submit';
    public static readonly ReviewSubtitle = 'Review your details before submitting — you can edit anything if needed.';

    public static readonly MAX_UPLOAD_FILE_SIZE = 10 * 1024 * 1024;
    public static readonly MAX_UPLOAD_FILES_COUNT = 4;
    public static readonly ACCEPTED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

    public static readonly Empty = 'Enter a password';
    public static readonly Weak = 'Weak';
    public static readonly Medium = 'Medium';
    public static readonly Strong = 'Strong';
    public static readonly PassMinLength: number = 8;

    public static readonly PassScoreWeak = '#EA5455';
    public static readonly PassScoreMedium = '#FF9F42';
    public static readonly PassScoreStrong = '#29C76F';

    public static readonly PassProgressbarWeak = 33;
    public static readonly PassProgressbarMedium = 66;
    public static readonly PassProgressbarStrong = 100;
}

export enum SignupStepEnum {
    OperatorDetails = 1,
    VerifyEmailOTP = 2,
    BusinessRequirements = 3,
    AccountCredentials = 4,
    ReviewSubmit = 5,
}

export enum BusinessDocumentsEnum {
    GovernmentIssuedId = 1,
    DTIorSECCertificate = 2,
    BIRCertificate = 3,
    LTFRBCertificate = 4,
    BusinessPermit = 5
}

export enum PassScoreEnum {
    Empty = 0,
    Weak1 = 1,
    Weak2 = 2,
    Medium = 3,
    Strong = 4
}
